<template>
  <textarea ref="simplemde"></textarea>
</template>

<script>
import content from '../../static/Edit-help.md';
import marked from 'lib/markdown';

export default {
  name: 'Help',
  async mounted() {
    const { default: SimpleMDE } = await import(/* webpackChunkName: "simplemde" */ 'simplemde');
    
    SimpleMDE.prototype.markdown = (text) => {
      if (marked) {
        // Initialize
        var markedOptions = {};

        // Update options
        if (this.options && this.options.renderingConfig && this.options.renderingConfig.singleLineBreaks === false) {
          markedOptions.breaks = false;
        } else {
          markedOptions.breaks = true;
        }

        if (
          this.options &&
          this.options.renderingConfig &&
          this.options.renderingConfig.codeSyntaxHighlighting === true &&
          window.hljs
        ) {
          markedOptions.highlight = function (code) {
            return window.hljs.highlightAuto(code).value;
          };
        }

        // Set options
        marked.setOptions(markedOptions);

        // Return
        return marked(text);
      }
    }

    this.simplemde = new SimpleMDE(this.options);
    this.simplemde.toggleSideBySide();

    document.getElementsByClassName('editor-toolbar')[0].style.display = 'none';
    [...document.querySelectorAll('.editor-preview-side, .CodeMirror')].map((i) => (i.style.top = '0px'));
  },
  data() {
    return {
      simplemde: null,
      options: {
        initialValue: content,
        element: this.$refs.simplemde,
        status: false,
        spellChecker: false,
      },
    };
  },
};
</script>

<style scoped>
@import '~simplemde/dist/simplemde.min.css';
</style>
